/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class StoreKitControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns any StoreKit transaction verification result
     * @throws ApiError
     */
    public storeKitControllerVerifyTransaction(
        requestBody: {
            jws: string;
        },
    ): CancelablePromise<{
        transactionId?: string;
        environment?: string;
        alreadyProcessed?: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/iap/verify-transaction',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any App Store Server Notification accepted
     * @throws ApiError
     */
    public storeKitControllerAppStoreNotification(
        requestBody?: Record<string, any>,
    ): CancelablePromise<{
        ok?: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/webhooks/apple/app-store-notifications',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
